import { handleError } from 'api/utils';
import { createRequest } from 'api/request';

export const getCollectedFees = async (state) => {
  return createRequest(`/v1/collected_fees`, state, {
    method: 'GET',
  }).then((res) => handleError(res));
};
